module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg4.42e5bb50.png";